import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AmenziAchitateComponent } from './amenzi-achitate.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [AmenziAchitateComponent],
  imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule],
})
export class AmenziAchitateModule {}
